import React from 'react';
//import LoadingButton from '@mui/lab/LoadingButton';
//import Button from '@mui/material/Button';
//import SendIcon from '@mui/icons-material/Send';
import {LoadingButton} from '@mui/lab';
import {Button} from '@mui/material';
import {Send as SendIcon} from '@mui/icons-material';

interface ButtonsProps {
  label: string;
  size?: 'small' | 'medium' | 'large';
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => Promise<void> | void;
  variant?: 'contained' | 'outlined';
  color?: '' | 'red';
  type?: 'button' | 'submit' | 'reset';
  sx?: any;
  startIcon?: any;
  endIcon?: any;
  manualLoading?: boolean;
  isDisabled?: boolean;
}

export const SubmitButton: React.FC<ButtonsProps> = ({ label, size = "small", onClick , type = "button", sx, manualLoading, isDisabled}) => {
  const [loading, setLoading] = React.useState(false);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (manualLoading === undefined) {
      setLoading(true);
    }
    if (onClick) {
      try {
        await onClick(event); // Wait for the entire onClick function to complete
      } catch (error) {
        console.error('Error during onClick:', error);
      }
    }
    if (manualLoading === undefined) {
      setLoading(false);
    }
  };

  return (
    <LoadingButton
      size={size}
      onClick={handleClick}
      endIcon={<SendIcon />}
      loading={manualLoading !== undefined ? manualLoading : loading}
      loadingPosition="end"
      disabled={loading || isDisabled} // Disables loading button when clicked
      variant="contained"
      type={type}
      sx={{
        width: '100%',
        minWidth: '55%',
        padding: '10px 25px',
        textTransform: 'none',
        fontSize: '15px',
        height: '50px',
        backgroundColor: loading ? 'var(--background-main)' : 'var(--naturGreen)',
        '&:hover': {
          background: 'var(--primary-colorSwitched)',
          transition: 'transform 0.3s, background-color 0.3s',
        },
        ...sx, // Merge additional styles if provided
      }}
    >
      <span>{label}</span>
    </LoadingButton>);
};

export const DefaultButton: React.FC<ButtonsProps> = ({ label, size = "small", onClick, variant="outlined", color="", sx, startIcon, endIcon, isDisabled=false}) => {

  const baseStyles = {
    width: '100%',
    minWidth: '55%',
    padding: '10px 25px',
    textTransform: 'none',
    fontSize: '15px',
    height: '50px',
    borderRadius: '5px'
  };

  const variantStyles = variant === "contained" ? {
    backgroundColor: color === "red" ? 'var(--red-button)' : 'var(--naturGreen)',
    '&:hover': {
      backgroundColor: 'var(--primary-color)',
      borderColor: 'var(--red-button) !important',
      transition: 'transform 0.3s, background-color 0.3s',
    },
  } : {
    borderColor: 'var(--naturGreen)',
    color: 'var(--primary-font)',
    '&:hover': {
      borderColor: 'var(--naturGreen) !important',
      transition: 'transform 0.3s, background-color 0.3s',
    },
  };

  return (
    <Button
      size={size}
      onClick={onClick}
      variant={variant}
      startIcon={ startIcon }
      endIcon = { endIcon }
      disabled = {isDisabled}
      sx={{
        ...baseStyles,
        ...variantStyles,
        ...sx, // Merge additional styles if provided
      }}
    >
      <span>{label}</span>
    </Button>);
};
